import { Instagram, ExternalLink, Mail, MapPin } from "lucide-react";

export default function FooterSection({ onAdminOpen }) {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="bg-black border-t border-ink-600 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-cinzel text-xl font-bold text-[#E5E5E5] tracking-widest mb-4">LUD BRADLEY</h3>
            <p className="font-manrope text-[#525252] text-sm leading-relaxed mb-6">
              Black &amp; Grey Realism Tattoo Artist.<br />
              New Westminster, BC, Canada.
            </p>
            <div className="flex items-center gap-4">
              <a
                data-testid="footer-instagram-link"
                href="https://www.instagram.com/ludbradleytattoo/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#525252] hover:text-verde transition-colors"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <p className="font-manrope text-[10px] tracking-[0.3em] uppercase text-verde mb-6">Navigate</p>
            <nav className="space-y-3">
              {["home", "about", "work", "accolades", "connect", "contact"].map(id => (
                <button
                  key={id}
                  onClick={() => scrollTo(id)}
                  className="block font-manrope text-xs text-[#525252] hover:text-[#E5E5E5] tracking-widest uppercase transition-colors"
                >
                  {id}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <p className="font-manrope text-[10px] tracking-[0.3em] uppercase text-verde mb-6">Contact</p>
            <div className="space-y-4">
              <a
                href="mailto:ludbradley.tattoo@gmail.com"
                className="flex items-center gap-3 text-[#525252] hover:text-verde transition-colors group"
              >
                <Mail size={14} className="flex-shrink-0" />
                <span className="font-manrope text-xs">ludbradley.tattoo@gmail.com</span>
              </a>
              <div className="flex items-start gap-3 text-[#525252]">
                <MapPin size={14} className="flex-shrink-0 mt-0.5" />
                <span className="font-manrope text-xs">314 6th Street<br />New Westminster, BC<br />Canada</span>
              </div>
              <div className="pt-2 space-y-2">
                <a
                  data-testid="footer-seminar-link"
                  href="https://ludbradleyclass.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 font-manrope text-[10px] tracking-widest uppercase text-[#525252] hover:text-verde transition-colors"
                >
                  ludbradleyclass.com <ExternalLink size={10} />
                </a>
                <a
                  data-testid="footer-shop-link"
                  href="https://avalontattoocollective.ca"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 font-manrope text-[10px] tracking-widest uppercase text-[#525252] hover:text-verde transition-colors"
                >
                  avalontattoocollective.ca <ExternalLink size={10} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-ink-600 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-manrope text-[10px] text-[#525252] tracking-widest">
            &copy; {new Date().getFullYear()} Lud Bradley. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <p className="font-manrope text-[10px] text-[#525252] tracking-widest uppercase">
              Black &amp; Grey Realism · New Westminster, BC
            </p>
            {/* Hidden admin dot */}
            <button
              data-testid="footer-admin-trigger"
              onClick={onAdminOpen}
              className="w-1.5 h-1.5 rounded-full bg-ink-600 hover:bg-verde/30 transition-colors"
              title=""
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
